import { Component, ViewChild, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventData, EventDetailsDialogComponent } from './eventdetails-dialog-component';
import { MatDialog } from '@angular/material/dialog';

// @Component({
//   selector: 'app-event-timeline',
//   template: `
//     <div>
//     <button (click)="scrollToLastImage()">Go to Last Image</button>
//     <button (click)="scrollToMiddle()">Go to Middle</button>
//     <div class="scroll-container" #scrollContainer (scroll)="onScroll($event)">
//       <div *ngFor="let event of events" class="event-thumbnail">
//         <img [src]="event.thumbnail" alt="Event Thumbnail" />
//       </div>
//     </div>
//     </div>
//   `,
//   styles: [
//     `
//       .scroll-container {
//         display: flex;
//         overflow-x: auto;
//         white-space: nowrap;
//       }
//       .event-thumbnail {
//         display: inline-block;
//         margin-right: 10px;
//       }
//       img {
//         height: 50px;
//         width: 50px;
//       }
//     `,
//   ],
// })
@Component({
  selector: 'app-event-timeline',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div>
   <div class="button-container">
      <button (click)="scrollToLastImage()">Live</button>
      <button (click)="scrollToMiddle()">Center</button>
      <button (click)="scrollToPosition('1hr')">1 Hour Ago</button>
      <button (click)="scrollToPosition('2hrs')">2 Hours Ago</button>
      <button (click)="scrollToPosition('yesterday')">Yesterday</button>
    </div>
    <div class="navigation-container">
      <button *ngIf="showLeftNav" class="nav-button left" (click)="scrollLeft()">&#9664;</button>
      <div class="scroll-container" #scrollContainer (scroll)="onScroll($event)">
        <div *ngFor="let event of events" class="event-thumbnail" 
          [ngClass]="{'active-thumbnail': event === activeEvent}"
          (click)="openEventDialog(event)">
          <img [src]="event.thumbnail" alt="Event Thumbnail" />
          <div class="event-info">
            <div class="d-flex" style="justify-content: space-around;">
                <div class="event-time">{{ event.date }}</div>
                <div class="event-time">{{ event.time }}</div>
            </div>
            <div class="event-date">{{ event.name }}</div>
          </div>
        </div>
      </div>
      <button *ngIf="showRightNav" class="nav-button right" (click)="scrollRight()">&#9654;</button>
    </div>
  </div>
  `,
  styles: [
    `
      :host {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        padding: 10px 0;
        z-index: 1000;
      }
      .button-container {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-bottom: 10px;
      }
      .navigation-container {
        display: flex;
        align-items: center;
        position: relative;
        gap: 10px;
      }
      .scroll-container {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        flex-grow: 1;
        padding: 0 30px;
        overflow-y: hidden;
      }
      .event-thumbnail {
        display: inline-block;
        margin-right: 10px;
      }
      img {
        height: 100px;
        width: 100px;
      }
      .event-thumbnail img {
        width: 130px;
        height: auto;
        cursor: pointer;
        border: 2px solid transparent;
        transition: all 0.3s ease;
      }
      .event-thumbnail.active-thumbnail img {
        border-color: #3f51b5; 
        height: 110px; 
        border-width: 3px;
      }
      
      .nav-button {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-color: rgba(0, 0, 0, 0.5);
        color: white;
        border: none;
        font-size: 24px;
        padding: 10px;
        cursor: pointer;
        z-index: 1;
      }
      .nav-button.left {
        left: 0;
      }
      .nav-button.right {
        right: 0;
      }
      .event-info {
        width: 100%;
        background-color: rgba(60, 90, 120, 0.9); /* Dark overlay for contrast */
        color: white;
        text-align: center;
        padding: 1px 0;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      .event-time {
        font-size: 9px;
        height: 10px;
      }

      .event-date {
        font-size: 9px;
        margin-top: 2px;
        height: 15px;
      }
    `,
  ],
})
export class EventTimelineComponent implements AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  events = [
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '3:30:07 PM',date: '14-10-2024',name: 'Event #1' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '4:15:22 PM', date: '14-10-2024', name: 'Event #2' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442' , time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442' , time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442' , time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442' , time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442' , time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3'},
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },
    { thumbnail: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442', time: '10:14:22 AM', date: '15-10-2024', name: 'Event #3' },

    // Add more events as needed
  ];
  activeEvent: EventData | null = null;

  private savedScrollPosition = 0;
  private scrollAmount = 100;
  showLeftNav = false;
  showRightNav = false;

  ngAfterViewInit() {
    // Restore the saved scroll position on view initialization
    //this.scrollContainer.nativeElement.scrollLeft = this.savedScrollPosition;
    this.updateNavigationButtons();
  }

  constructor(private dialog: MatDialog) {}

  onScroll(event: Event) {
    // Save the current scroll position
    //this.savedScrollPosition = (event.target as HTMLElement).scrollLeft;
    this.updateNavigationButtons();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateNavigationButtons();
    console.log('on resize');
  }

  private updateNavigationButtons() {
    const container = this.scrollContainer.nativeElement;
    this.showLeftNav = container.scrollLeft > 0;
    this.showRightNav = container.scrollLeft < container.scrollWidth - container.clientWidth;
  }

  scrollToLastImage() {
    const container = this.scrollContainer.nativeElement;
    // Calculate scroll position for the last image
    const lastImageScrollPosition = container.scrollWidth - container.clientWidth;
    // Set the scroll position to the last image
    container.scrollLeft = lastImageScrollPosition;
  }

  scrollToMiddle() {
    const container = this.scrollContainer.nativeElement;
    // Calculate scroll position for the middle
    const middleScrollPosition = (container.scrollWidth - container.clientWidth) / 2;
    // Set the scroll position to the middle
    container.scrollLeft = middleScrollPosition;
  }

  scrollToPosition(timeframe: string) {
    const container = this.scrollContainer.nativeElement;
    const totalDuration = 24; // Assuming 24 hours in a day for simplicity
    let targetPosition = 0;

    switch (timeframe) {
      case '1hr':
        targetPosition = container.scrollWidth * (totalDuration - 1) / totalDuration;
        break;
      case '2hrs':
        targetPosition = container.scrollWidth * (totalDuration - 2) / totalDuration;
        break;
      case 'yesterday':
        targetPosition = 0; // Start of the timeline, assuming yesterday is the earliest event
        break;
      default:
        targetPosition = 0;
    }

    container.scrollLeft = targetPosition;
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollLeft -= this.scrollAmount;
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollLeft += this.scrollAmount;
  }

  openEventDialog(event: any): void {
    this.activeEvent = event;
    const dialogRef = this.dialog.open(EventDetailsDialogComponent, {
      width: '300px',
      data: { name: event.name, time: event.time, thumbnail: event.thumbnail }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'deleted') {
        this.deleteEvent(event);
        if (this.activeEvent === event) {
          this.activeEvent = null;
        }
      }
    });
  }

  deleteEvent(event: any): void {
    this.events = this.events.filter(e => e !== event);
  }

}
